
import React from 'react';
import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Image from '@tiptap/extension-image';
import { EditorMenuBar } from './EditorMenuBar';
import { UseFormRegister, UseFormSetValue } from 'react-hook-form';
import { BlogFormData } from '../types/blog';

interface BlogPostEditorProps {
  initialContent?: string;
  register: UseFormRegister<BlogFormData>;
  setValue: UseFormSetValue<BlogFormData>;
}

export const BlogPostEditor = ({ initialContent, register, setValue }: BlogPostEditorProps) => {
  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        heading: {
          levels: [1, 2],
        },
      }),
      Image.configure({
        allowBase64: true,
        HTMLAttributes: {
          class: 'rounded-lg max-h-[500px] object-cover',
        },
      }),
    ],
    content: initialContent || '',
    editorProps: {
      attributes: {
        class: 'prose prose-lg focus:outline-none max-w-none h-full min-h-[300px] px-6 py-4 overflow-y-auto prose-img:mx-auto prose-headings:text-primary/90 prose-p:text-gray-700 prose-p:leading-relaxed',
      },
    },
    onUpdate: ({ editor }) => {
      const content = editor.getHTML();
      setValue('content', content);
    },
  });

  return (
    <div className="h-full flex flex-col overflow-hidden">
      <EditorMenuBar editor={editor} className="border-b bg-[#F1F0FB]/50" />
      <div className="flex-grow overflow-auto bg-white">
        <EditorContent editor={editor} className="h-full" />
      </div>
    </div>
  );
};

